import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import classNames from 'classnames';
import ArrowBackIcon from 'material-design-icons/navigation/svg/production/ic_arrow_back_24px.svg';
import ArrowForwardIcon from 'material-design-icons/navigation/svg/production/ic_arrow_forward_24px.svg';

import c from './ReleaseCalendar.less';

export default class MonthView extends Component {
  static propTypes = {
    currentYear: PropTypes.number.isRequired,
    lastYear: PropTypes.number.isRequired,
    firstYear: PropTypes.number.isRequired,
    currentMonth: PropTypes.number.isRequired,
    lastMonth: PropTypes.number.isRequired,
    firstMonth: PropTypes.number.isRequired,
    onMonthSelect: PropTypes.func.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.setState({
      currentYear: this.props.currentYear,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.currentYear !== this.props.currentYear) {
      this.setState({
        currentYear: nextProps.currentYear,
      });
    }
  }

  get hasPreviousYear() {
    const { firstYear } = this.props;
    const { currentYear } = this.state;

    return moment().date(1).month(0).year(currentYear)
      .isAfter(moment().date(1).month(0).year(firstYear));
  }

  get hasNextYear() {
    const { lastYear } = this.props;
    const { currentYear } = this.state;

    return moment().date(1).month(0).year(currentYear)
      .isBefore(moment().date(1).month(0).year(lastYear));
  }

  handleShowPreviousYear = () => {
    const { currentYear } = this.state;
    const previousYear = moment().date(1).month(0).year(currentYear)
      .subtract(1, 'year');

    this.setState({
      currentYear: previousYear.year(),
    });
  };

  handleShowNextYear = () => {
    const { currentYear } = this.state;
    const nextYear = moment().date(1).month(0).year(currentYear)
      .add(1, 'year');

    this.setState({
      currentYear: nextYear.year(),
    });
  };

  render() {
    const {
      currentMonth, lastYear, lastMonth, firstYear, firstMonth, onMonthSelect,
    } = this.props;
    const { currentYear } = this.state;

    const selectedYear = moment().date(1).month(currentMonth).year(currentYear);

    const iteratingMonth = moment().date(1).month(0).year(currentYear);
    const endOfYear = moment().date(1).month(11).year(currentYear);

    const months = [];

    while (iteratingMonth.isSameOrBefore(endOfYear)) {
      const isActive = iteratingMonth.month() === currentMonth && iteratingMonth.year() === this.props.currentYear;
      const isDisabled = (currentYear === lastYear && iteratingMonth.month() > lastMonth)
        || (currentYear === firstYear && iteratingMonth.month() < firstMonth);

      const cellClasses = classNames(c.monthCell, {
        [c.active]: isActive,
        [c.selectable]: !isDisabled,
      });

      months.push(
        <li
          className={cellClasses}
          key={iteratingMonth.month()}
        >
          <button
            type="button"
            disabled={isDisabled}
            onClick={((date) => () => {
              onMonthSelect(date);
            })(iteratingMonth.clone())}
          >
            {iteratingMonth.format('MMM')}
          </button>
        </li>,
      );
      iteratingMonth.add(1, 'month');
    }

    return (
      <div className={c.monthViewContainer}>
        <div className={c.navigation}>
          <button
            type="button"
            className={c.monthChanger}
            onClick={this.handleShowPreviousYear}
            disabled={!this.hasPreviousYear}
          >
            <ArrowBackIcon />
          </button>
          <span className={c.dateView}>{selectedYear.format('YYYY')}</span>
          <button
            type="button"
            className={c.monthChanger}
            onClick={this.handleShowNextYear}
            disabled={!this.hasNextYear}
          >
            <ArrowForwardIcon />
          </button>
        </div>
        <ul className={c.monthsContainer}>
          {months}
        </ul>
      </div>
    );
  }
}
